export const selectTransactions = state => state.transactions;
export const selectTransactionsList = state => selectTransactions(state).items;
export const selectTransactionBalance = state =>
  selectTransactions(state).balance;
export const selectTransactionOverdueAmount = state =>
  selectTransactions(state).overdueAmount;
export const selectTransactionsListCount = state =>
  selectTransactions(state).count;
export const selectTransactionsQueryOptions = state => {
  const { options } = selectTransactions(state);

  Object.keys(options).forEach(key => {
    if (options[key] === '') {
      delete options[key];
    }
  });

  return options;
};
export const selectTransactionDetail = state =>
  selectTransactions(state).detail.item;
export const selectTransactionDetailComplements = state =>
  selectTransactions(state).detail.complements;
export const selectTransactionDetailRelatedInvoices = state =>
  selectTransactions(state).detail.relatedInvoices;
export const selectTransactionDetailError = state =>
  selectTransactions(state).detail.error;
